import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone } from 'lucide-react';
import { Button } from '../ui/button';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/about', label: 'About Us' },
    { path: '/services', label: 'Services' },
    { path: '/projects', label: 'Projects' },
    { path: '/clients', label: 'Clients' },
    { path: '/contact', label: 'Contact' }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-[#000000] border-b border-white/10 ">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 sm:h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <img 
              src="/elemech-logo.png" 
              alt="Elemech Engineering"
              className="h-10 sm:h-12 md:h-16 w-auto object-contain"
              style={{
                mixBlendMode: 'normal',
                display: 'block'
              }}
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium transition-colors duration-300 ${
                  isActive(link.path)
                    ? 'text-[#b00000]'
                    : 'text-[#c0c0c0] hover:text-white'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </nav>

          {/* CTA Button */}
          <div className="hidden lg:flex items-center gap-4">
            <a href="tel:+919766110312" className="flex items-center gap-2 text-[#c0c0c0] hover:text-white transition-colors">
              <Phone className="w-4 h-4" />
              <span className="text-sm">+91 9766110312</span>
            </a>
            <Link to="/contact">
              <Button className="bg-[#FFD700] hover:bg-[#FFC000] text-black font-semibold rounded-none none px-6 h-11 transition-all duration-300 ">
                Get a Quote
              </Button>
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="lg:hidden text-white p-2"
          >
            {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <div className="lg:hidden bg-[#000000]/95 backdrop-blur-lg border-t border-white/10">
          <nav className="flex flex-col py-4">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsMenuOpen(false)}
                className={`px-6 py-3 text-sm font-medium transition-colors ${
                  isActive(link.path)
                    ? 'text-[#b00000] bg-[#000000]'
                    : 'text-[#c0c0c0] hover:text-white hover:bg-[#000000]'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <div className="px-6 py-4 border-t border-white/10 mt-2">
              <Link to="/contact" onClick={() => setIsMenuOpen(false)}>
                <Button className="w-full bg-[#FFD700] hover:bg-[#FFC000] text-black font-semibold rounded-none none h-11 ">
                  Get a Quote
                </Button>
              </Link>
            </div>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
